const DEBUG = window.calc_handbooks.calc.debug

const DEFAULT_ERR_TEXT = 'Для вирішення проблеми зверніться до наших операторів'

const DD = new class {
	log(...data) {DEBUG ? console.log(...data) : null}
	warn(...data) {DEBUG ? console.warn(...data) : null}
	error(...data) {DEBUG ? console.error(...data) : null}
	info(...data) {DEBUG ? console.info(...data) : null}
	bool(result, ...data) {
		if(DEBUG !== true) return false
		result ? this.log('✅', ...data) : this.error('❌', ...data)
	}
}

const today = new Date()


document.addEventListener('DOMContentLoaded', ()=>{
	const SwalToast = Swal.mixin({
		toast: true,
		position: 'top',
		showConfirmButton: false,
		showCloseButton: true,
		timer: 7000,
		backdrop: false,
		timerProgressBar: true,
		didOpen: (toast) => {
			toast.addEventListener('mouseenter', Swal.stopTimer)
			toast.addEventListener('mouseleave', Swal.resumeTimer)
		}
	})
})



function showServerError() {
	console.log('img')
	Swal.fire({
		title: 'Вибачте, помилка з&nbsp;нашого боку',
		html: 'Будь ласка, зв\'яжіться з&nbsp;нами або&nbsp;спробуйте оновити сторінку трохи пізніше.',
		icon: 'warning',
		showCloseButton: true,
		showCancelButton: true,
		confirmButtonText: `Закрити`,
		cancelButtonText: `<a href="https://greentravel.ua/ua/contacts/" target="_blank">Контакти</a>`,
	})
}


function getCookie(name) {
	const value = `; ${document.cookie}`
	const parts = value.split(`; ${name}=`)
	if (parts.length === 2) return parts.pop().split(';').shift()
}


function saveCookie(cookieName, cookieValue, expirationMins) {
  var date = new Date()
  // date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
  date.setTime(date.getTime() + (expirationMins * 1000 * 60));
  var expires = "expires=" + date.toUTCString();
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}


function deleteCookie(cookieName) {
  document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
}


// переключение класса
function toggleClass(el, className = "active", self = this) {
	if(typeof el == 'string') el = document.querySelector(el)
	console.log(el, el.classList)
	el.classList.toggle(className)
	if(typeof self != 'undefined') self.classList.toggle('_toggled')
}


/**
	 * Возвращает строку-перевод.
	 * @date 12/3/2024 - 10:13:02 AM
	 *
	 * @param {object} $text = {ua:'украинский', ru:'русский'}
	 * @returns {string}
	 */
function getLang($text) {
	if(typeof window.LANG != 'undefined') {
		return $text[window.LANG]
	} else {
		 return $text[0]
	}
}




/**
 * @function checkInput
 * @description Проверяет входное значение на соответствие регулярному выражению и устанавливает минимальную и максимальную длину.
 * @param {HTMLInputElement} input - The input to check.
 * @param {number} minLength - The minimal length of the input value.
 * @param {number} maxLength - The maximal length of the input value.
 * @param {RegExp} [regex=/./] - The regular expression to check the input value against.
 */
function checkInput(input, minLength, maxLength, regex = /.*/) {
	if (input.value.length > maxLength) {
			input.value = input.value.slice(0, maxLength);
	}

	// Проверяем на регулярное выражение
	if (!regex.test(input.value)) {
			input.setCustomValidity("Введенные данные не соответствуют требуемому формату");
	} else {
			input.setCustomValidity("");  // Убираем сообщение об ошибке, если всё в порядке
	}

	// Проверяем минимальную длину при потере фокуса
	input.onblur = function() {
			if (input.value.length < minLength) {
					input.setCustomValidity("Минимальное количество символов: " + minLength);
			} else {
					input.setCustomValidity("");  // Убираем сообщение, если длина нормальная
			}
	};
}



/**
 * Удаляет ненужные символы из поля ввода в зависимости от указанного типа
 * @param {string} type - The type of symbols to remove ('lat' for Latin, 'cyr' for Cyrillic).
 * @param {string} elSelector - The selector of the input element to be processed.
 */
function checkTypeofSymbols(type, el) {
	let inputField = null
	if (typeof el === 'string') inputField = document.querySelector(el)
	else if (el instanceof HTMLElement) inputField = el

	if(inputField) {
		const regex = {
			lat: /[^a-zA-Z0-9\s-]/g,
			cyr: /[^а-яА-ЯіiIІїЇєЄґҐ0-9\s-]/g
		};
		inputField.value = inputField.value.replace(regex[type], '')
	}
}
